import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import history from 'app/routes/history';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  organisationProductSchema,
  organisationProductListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/organisationProducts/actions';
import { OrganisationProductsActionTypes as types } from 'app/ducks/organisationProducts/types';

function* createOrganisationProductSaga(action): any {
  yield put(sagaActions.createOrganisationProductPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationProducts.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, organisationProductSchema);
    history.push(`/competitions/${action.payload.competition.id}`);
    yield put(sagaActions.createOrganisationProductSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createOrganisationProductFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateOrganisationProductSaga(action): any {
  yield put(sagaActions.updateOrganisationProductPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationProducts.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, organisationProductSchema);

    yield put(sagaActions.updateOrganisationProductSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateOrganisationProductFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getOrganisationProductSaga(action): any {
  yield put(sagaActions.getOrganisationProductPending());

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationProducts.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, organisationProductSchema);
    yield put(sagaActions.getOrganisationProductSuccess(normalizedResponse));
    return normalizedResponse.entities.organisationProducts[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getOrganisationProductFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllOrganisationProductsSaga(action): any {
  yield put(
    sagaActions.getAllOrganisationProductsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());
  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.organisationProducts.pagination),
    )
    : action.payload.pagination;
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationProducts.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(
      response,
      organisationProductListSchema,
    );

    yield put(
      sagaActions.getAllOrganisationProductsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllOrganisationProductsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createOrganisationProductSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_ORGANISATION_PRODUCT_REQUESTED,
    createOrganisationProductSaga,
  );
}

function* updateOrganisationProductSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_ORGANISATION_PRODUCT_REQUESTED,
    updateOrganisationProductSaga,
  );
}

function* getOrganisationProductSagaWatcher(): any {
  yield takeLatest(
    types.GET_ORGANISATION_PRODUCT_REQUESTED,
    getOrganisationProductSaga,
  );
}

function* getAllOrganisationProductsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_ORGANISATION_PRODUCTS_REQUESTED,
    getAllOrganisationProductsSaga,
  );
}

export default function* root(): any {
  yield all([
    createOrganisationProductSagaWatcher(),
    updateOrganisationProductSagaWatcher(),
    getOrganisationProductSagaWatcher(),
    getAllOrganisationProductsSagaWatcher(),
  ]);
}
